import Vue from 'vue'
import Vuex from 'vuex'

import bookingModule from './booking-module'
import authModule from './auth-module'
import airportModule from './airport-module'
import vehicleModule from './vehicle-module'
import productModule from './product-module'
import extraModule from './extra-module'
import featureModule from './feature-module'
import configurationModule from './configuration-module'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: true, // TODO: turn off for production
    modules: {
        booking: bookingModule,
        auth: authModule,
        airport: airportModule,
        vehicle: vehicleModule,
        product: productModule,
        extra: extraModule,
        feature: featureModule,
        configuration: configurationModule
    }
})
